import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { ICustomerUser, IOrder } from '@care-portals/api-interfaces';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { Observable, Subscription } from 'rxjs';
import { OrdersFacade } from '../../../+store/order/order.facade';
import { dateCompare } from '@care-portals/shared';
import { ORDER_STATUSES } from '@care-portals/data';

@Component({
  selector: 'my-health-admin-find-order',
  templateUrl: './find-order.component.html',
  styleUrls: ['./find-order.component.less']
})
export class FindOrderComponent implements OnInit, OnDestroy {
  @Input() customerId: string;
  isLoading$: Observable<boolean>;
  orders: IOrder[];
  ordersSub: Subscription;
  statusNames;
  checkedId: number;
  listOfColumn = [
    {
      title: 'Order #',
      compare: (a: IOrder, b: IOrder) =>
        (
          (a.customer as ICustomerUser).firstName +
          ' ' +
          (a.customer as ICustomerUser).lastName
        ).localeCompare(
          (b.customer as ICustomerUser).firstName +
            ' ' +
            (b.customer as ICustomerUser).lastName
        ),
      sortOrder: 'descend'
    },
    {
      title: 'Created Date',
      compare: (a: IOrder, b: IOrder) => dateCompare(a.createdAt, b.createdAt)
    },
    {
      title: 'Shipped Date',
      compare: (a: IOrder, b: IOrder) => dateCompare(a.shippedAt, b.shippedAt)
    },
    {
      title: 'Status',
      compare: (a: IOrder, b: IOrder) => (a.status < b.status ? -1 : 1)
    },
    {
      title: 'Total Price',
      compare: (a: IOrder, b: IOrder) => a.totalAmount - b.totalAmount
    }
  ];

  constructor(
    public router: Router,
    private orderFacade: OrdersFacade,
    private nzDrawerRef: NzDrawerRef,
    private notification: NzNotificationService
  ) {
    this.isLoading$ = this.orderFacade.loadingOrders$;
    this.ordersSub = this.orderFacade.orders$.subscribe(res => {
      this.orders = Object.keys(res).map(key => {
        return { ...res[key] };
      });
    });
  }

  ngOnDestroy(): void {
    this.ordersSub.unsubscribe();
  }

  ngOnInit() {
    this.checkedId = null;
    this.statusNames = {};
    Object.keys(ORDER_STATUSES)
      .map(key => ORDER_STATUSES[key])
      .filter(status => status.show)
      .map(status => {
        Object.assign(this.statusNames, { [status.key]: status.name });
      });
    this.orderFacade.loadOrders(null, { customerId: this.customerId });
  }

  onItemChecked(id: number, checked: boolean): void {
    if (checked) {
      this.checkedId = id;
    } else {
      this.checkedId = null;
    }
  }

  toggleSelection(id: number) {
    this.checkedId = this.checkedId === id ? null : id;
  }

  chooseOrder() {
    if (!this.checkedId) {
      this.notification.warning('Order was not chosen.', '');
      return;
    }
    this.nzDrawerRef.close(this.checkedId);
  }

  openOrderDetails(orderId: string) {
    this.orderFacade.openOrderDetails(orderId);
  }
}
